import http from "@/libs/http";
// 全国青少年体育赛事备案管理;
const record = {
  /**审批赛事 - 系统管理员、青少司 */
  game_filingApprove: ApproveVO => {
    return http.post(http.formatUrl("game_filing/approve"), ApproveVO);
  },
  /**批量审批赛事 - 系统管理员、青少司 */
  game_filingApproveBatch: BatchApproveVO => {
    return http.post(http.formatUrl("game_filing/approve/batch"), BatchApproveVO);
  },
  /**新建训练营 - 系统管理员、项目中心、省、操作员 */
  game_filingCampInsert: game_filingVO => {
    return http.post(http.formatUrl("game_filing/camp/insert"), game_filingVO);
  },
  /**修改训练营 - 系统管理员、项目中心、省 、操作员 */
  game_filingCampUpdate: game_filingVO => {
    return http.post(http.formatUrl("game_filing/camp/update"), game_filingVO);
  },
  /**删除赛事 - 系统管理员、项目中心、省 */
  game_filingDelete: game_filingId => {
    return http.post(http.formatUrl("game_filing/delete"), game_filingId);
  },
  /**查询赛事详情 - 所有登录用户 */
  game_filingInfo: game_filingId => {
    return http.get(http.formatUrl("game_filing/info"), game_filingId);
  },
  /**新建赛事 - 系统管理员、项目中心、省 */
  game_filingInsert: game_filingVO => {
    return http.post(http.formatUrl("game_filing/insert"), game_filingVO);
  },
  /**查询赛事分页列表 - 所有登录用户 */
  game_filingPageList: game_filingPageListVO => {
    return http.get(http.formatUrl("game_filing/pagelist"), game_filingPageListVO);
  },
  /**撤销已提交的赛事 - 系统管理员、项目中心、省 */
  game_filingRevoke: game_filingId => {
    return http.post(http.formatUrl("game_filing/revoke"), game_filingId);
  },
  /**提交赛事 - 系统管理员、项目中心、省 */
  game_filingSubmit: game_filingId => {
    return http.post(http.formatUrl("game_filing/submit"), game_filingId);
  },
  /**批量提交赛事 - 系统管理员、项目中心、省 */
  game_filingSubmitBatch: Batchgame_filingId => {
    return http.post(http.formatUrl("game_filing/submit/batch"), Batchgame_filingId);
  },
  /**修改赛事 - 系统管理员、项目中心、省 */
  game_filingUpdate: game_filingVO => {
    return http.post(http.formatUrl("game_filing/update"), game_filingVO);
  },
  /**查询分页列表 - 所有登录用户 */
  game_filing_filingPageList: PlanOtherPageListVO => {
    return http.get(http.formatUrl("game_filing_filing/pagelist"), PlanOtherPageListVO);
  },
  /**s设置当前填报年度 */
  game_filing_settingYears: PlanOtherPageListVO => {
    return http.post(http.formatUrl("game_filing/year/set"), PlanOtherPageListVO);
  }
  // /**新建 - 系统管理员、项目中心、省、操作员 */
  // planOtherInsert: PlanOtherVO => {
  //   return http.post(http.formatUrl("plan/other/insert"), PlanOtherVO);
  // },
  // /**修改 - 系统管理员、项目中心、省 、操作员 */
  // planOtherUpdate: PlanOtherVO => {
  //   return http.post(http.formatUrl("plan/other/update"), PlanOtherVO);
  // },
  // /**审批 - 系统管理员、青少司 */
  // planOtherApprove: ApproveVO => {
  //   return http.post(http.formatUrl("plan/other/approve"), ApproveVO);
  // },
  // /**批量审批 - 系统管理员、青少司 */
  // planOtherApproveBatch: BatchApproveVO => {
  //   return http.post(http.formatUrl("plan/other/approve/batch"), BatchApproveVO);
  // },
  // /**删除 - 系统管理员、项目中心、省、操作员 */
  // planOtherDelete: game_filingId => {
  //   return http.post(http.formatUrl("plan/other/delete"), game_filingId);
  // },
  // /**撤销已提交的 - 系统管理员、项目中心、省 */
  // planOtherRevoke: game_filingId => {
  //   return http.post(http.formatUrl("plan/other/revoke"), game_filingId);
  // },
  // /**提交 - 系统管理员、项目中心、省 */
  // planOtherSubmit: game_filingId => {
  //   return http.post(http.formatUrl("plan/other/submit"), game_filingId);
  // },
  // /**批量提交 - 系统管理员、项目中心、省 */
  // planOtherSubmitBatch: Batchgame_filingId => {
  //   return http.post(http.formatUrl("plan/other/submit/batch"), Batchgame_filingId);
  // },
  // /**用户列表 */
  // userListPage: PlanOtherPageListVO => {
  //   return http.get(http.formatUrl("user/list/page"), PlanOtherPageListVO);
  // },
  // /**获取类型计划需要用到的字典数据 - 所有登录用户 */
  // planOtherItemDict: PlanOtherItemDictVO => {
  //   return http.get(http.formatUrl("plan/other/item/dict"), PlanOtherItemDictVO);
  // }
};
export default record;
